import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
Vue.config.errorHandler = function(err) {
  console.error('[Vue Error]', err)
}

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
